import React, { useEffect } from "react";
import { Row, Col } from "components/common";
import { Divider } from "antd";
import Helmet from "react-helmet";
import ReactCountryFlag from "react-country-flag";
import { FaTelegram, FaYoutube } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import ContactImage from "assets/images/support/contact_us.png";
import CallImg from "assets/images/support/call.svg";
import MapImg from "assets/images/support/map.svg";
import EmailImg from "assets/images/support/email.svg";
import { IoIosChatboxes } from "react-icons/io";
import styled from "styled-components";

export default function IndexPage() {
  useEffect(() => {
    var iframes = document.querySelectorAll("iframe");
    for (var i = 0; i < iframes.length; i++) {
      iframes[i].style.display = "block";
    }
    return () => {
      var iframes = document.querySelectorAll("iframe");
      for (var i = 0; i < iframes.length; i++) {
        iframes[i].style.display = "none";
      }
    };
  }, []);
  return (
    <Wrapper>
      <div className="main-container">
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <div className="white-rounded-bg">
              <img src={ContactImage} className="contact-us-banner" alt="" />
            </div>
          </Col>
          <Col xs={24} className="support-nueva">support@nuevalife.com</Col>
          
        </Row>
      </div>
      <Helmet>
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=65b733ca-6f80-4823-830c-482d5fddf522"
        >
          {" "}
        </script>
        {/* <script>{`
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:2912584,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}</script> */}
      </Helmet>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 80px;
  .main-container {
  }
  .divider {
    margin: 0;
    width: 50px;
    min-width: 50px;
    border-top: 5px solid #00b2ff;
  }
  .contact-us-banner {
    width: 100%;
    border-radius: 8px;
    max-height: 300px;
    object-fit: cover;
    object-position: left;
  }
  .info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      height: 25px;
      width: 40px;
    }
  }
  .title {
    align-items: center;
    margin: 10px 0;
    font-size: 22px;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    margin: 2px;
    text-align: center;
  }
  strong {
    font-size: 18px;
    margin: 10px 0 5px;
    text-align: center;
    color: #232838;
  }
  .customer-support-row {
    justify-content: center;
  }
  .support-nueva{
    display: flex;
    justify-content: center;
    font-size: 24px;
    font-weight: 600;
    color: #000;
    width: 100%;
    height: 200px;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0px 0px 5px -3px grey;
  }
  .info-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    max-width: 250px;
    margin: 0 auto;
    height: 100%;
    min-height: 200px;
    padding: 20px;
    background: #f5fcff;
    border: 1px solid rgba(0, 178, 255, 0.1);
    border-radius: 8px;
    img {
      height: 40px;
      width: 40px;
    }
    h5 {
      margin-bottom: 20px;
    }
    a {
      overflow-wrap: anywhere;
      color: #05c1ff;
    }
    svg {
      color: #05c1ff;
      font-size: 40px;
    }
  }
  .return-addresses {
    .customer-support-row {
      justify-content: flex-start;
    }
    .info-text {
      background: rgba(56, 74, 114, 0.1);
      border: 1px solid rgba(56, 74, 114, 0.1);
      border-radius: 8px;
      padding: 30px 10px;
      max-width: 500px;
      label {
        font-weight: 600;
      }
    }
  }
  .info-container.social {
    background: rgba(204, 240, 255, 20%);
    box-shadow: 0px 0px 2px rgba(145, 158, 171, 0.2),
      0px 12px 24px -4px rgba(145, 158, 171, 0.12) !important;
    border-radius: 16px !important;
    padding: 24px !important;
  }
  .social-icons {
    font-size: 36px;
    margin-top: 20px;
    svg {
      margin: 0 12px;
      cursor: pointer;
      color: #05c1ff;
    }
  }
  @media only screen and (max-width: 767px) {
    .contact-us-banner {
      min-height: 170px;
    }
  }
`;
